import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { PositionService } from './position.service';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class PositionResolver implements Resolve<any> {

  constructor(private positionService: PositionService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    return this.positionService.getWallet(["BTC", "EUR", "USD", "JPY", "BCA"]);
  }
}
